import CommonConfig from 'fn-common-ui';
import localCommonConfig from './localCommon.configuration';

var config = Object.assign(CommonConfig.CommonConfig, {
	haloLogin: 'https://oidc.idp.flogin.att.com/mga/sps/oauth/oauth20/authorize?redirect_uri=https%3A%2F%2Fappcontrol.firstnet.att.com%2Foauth%2Fvalidate&scope=openid&nonce=AXgulLLOfRY1kxPjJDQw&response_type=id_token&response_mode=form_post&state=AXgulLLOfRY1kxPjJDQw&scope=openid&client_id=m14341',
  haloLogout: 'https://fcontent.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&appName=m14341',

	appCatalog: 'https://apps.firstnet.att.com/',
  appControl: 'https://appcontrol.firstnet.att.com/',
  localControl: 'https://localcontrol.firstnet.att.com/',
  firstnetTraining: 'https://training.firstnet.att.com/',
  devPortal: 'https://developer.firstnet.com/developer/mvc/auth/login?siteId=PORTALPROPER',
  devGeneralChecklistForm: 'https://developer.firstnet.com/static-assets/documents/firstnet/resources-downloadable-resources/Verified_App_Checklist.xlsx',
  devCertifiedChecklistForm: 'https://developer.firstnet.com/static-assets/documents/firstnet/resources-downloadable-resources/Certified_App_Checklist.xlsx',
  devSourceCodeScanInfo:"https://developer.firstnet.com/static-assets/documents/firstnet/resource-catalog/FirstNet_Application_Testing_and_Security_Requirements.pdf",
  firstNetPrivacy: 'https://www.firstnet.com/privacy-policy.html',
  firstNetTermsConditions: 'https://www.firstnet.com/terms-and-conditions.html',
  firstNetAccessibility: 'https://www.firstnet.com/accessibility.html',
  adobeHeaderScript: 'https://www.att.com/scripts/adobe/prod/detm-container-hdr.js',
  adobeFooterScript: 'https://www.att.com/scripts/adobe/prod/detm-container-ftr.js',
}, localCommonConfig);

config.createDevPortalLinks();

export default config
